// extracted by mini-css-extract-plugin
export var buttons = "MobileNavbar-module--buttons--c9548";
export var display = "MobileNavbar-module--display--9015a";
export var display_none = "MobileNavbar-module--display_none--064dc";
export var download_section = "MobileNavbar-module--download_section--88764";
export var menu_links = "MobileNavbar-module--menu_links--89dee";
export var mobile_navbar_container = "MobileNavbar-module--mobile_navbar_container--45bed";
export var selectLanguage = "MobileNavbar-module--selectLanguage--f7962";
export var select_container = "MobileNavbar-module--select_container--e1963";